import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const chartElement = css`
	.figureNumber {
		width: 150px;
	}

	.chartPreviewWrapper {
		border: 1px solid ${colors.border};
		border-radius: 4px;
		padding: 10px;

		display: flex;
		justify-content: center;

		svg {
			height: 300px;
		}
	}

	.dataTableContainer {
		border-bottom: 1px solid ${colors.border};
		padding-bottom: 10px;
	}

	.title {
		font-weight: 600;
		margin-bottom: 30px;
	}

	.select {
		width: 150px;
	}

	.number {
		width: 100px;
	}

	.block {
		display: flex;
		align-items: baseline;
		padding: 10px 0;
		border-bottom: 1px solid ${colors.border};

		.form-group:not(:first-child) {
			margin-left: 25px;
		}
	}

	.tableButtonsBlock {
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}

	.form-group {
		margin-bottom: 0px;
	}

	.form-check {
		display: flex;
		align-items: center;
	}

	input {
		height: 2em;
	}

	.marginsBlock {
		display: flex;
		flex-wrap: wrap;

		.form-group {
			margin-left: 10px !important;
		}
	}

	.loadButton {
		margin-left: 15px;
		color: ${colors.mainText};
		border-color: ${colors.border};

		:hover {
			color: ${colors.hoverText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}
	}
`;

export const loadDataTab = css`
	padding: 25px 16px;
`;

export const colorCell = css`
	display: flex;
	align-items: center;
	position: relative;

	.colorSquare {
		min-width: 20px;
		height: 20px;
		border-radius: 4px;
		border: 1px solid ${colors.border};
		cursor: pointer;
		margin-right: 10px;
	}

	.colorInput {
		width: 100%;
		outline: none;
		font-size: 12px;
		color: ${colors.infoText};
		border: 1px solid ${colors.border};
		border-radius: 4px;
		margin-left: 5px;
		padding: 0 7px;
	}
`;

export const colorPicker = css`
	position: absolute;
	bottom: -20px;
	z-index: 100;
`;

export const chartDataTableStyle = css`
	margin-top: 15px;

	.addColumn {
		padding: 0 5px !important;
		text-align: left;
	}

	.addButton {
		top: 14px !important;
		right: -2px !important;
	}

	.cell {
		text-align: left !important;
		padding: 3px 6px !important;
		word-break: break-word;
		width: 110px;
	}

	.cell:last-child {
		width: 40px;
		text-align: center !important;
	}

	tr:nth-child(2) {
		.cell {
			vertical-align: top !important;
		}
	}
`;

export const chartOptionsBlockStyles = css`
	display: flex;
	justify-content: flex-start;
	margin-top: 10px;

	button {
		margin-right: 10px;
		font-size: 12px;
		padding: 5px;
		border-color: ${colors.border};

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}
	}
`;

export const chartDataTableWrapperStyle = css`
	overflow-x: auto;
`;

export const rowOptionsStyle = css`
	position: relative;
	cursor: pointer;
`;

export const dropdownStyle = css`
	cursor: pointer;
	position: absolute;

	.dropdownItem {
		cursor: pointer;
		padding: 5px 10px;
		text-align: left;

		:hover {
			background-color: #f5f5f5;
		}
	}

	.deleteDropdownItem {
		color: #c40505bf;
	}
`;

export const rowDropdownStyle = css`
	min-width: 150px;
`;

export const columnDropdownStyle = css`
	width: 215px !important;
	text-align: left;
`;
